import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import store from './store'


import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

// import "vue-material-design-icons/styles.css"

import "./vee-validate"

import VueMatomo from 'vue-matomo'


import VueMoment from 'vue-moment'
Vue.use(VueMoment);

// const moment = require('moment')



// import GAuth from 'vue-google-oauth2'
// const gauthOption = {
//   // clientId: '831532615144-m9fspm39mbe5sr0mjl6kpplhlgje01ii.apps.googleusercontent.com',  //'CLIENT_ID.apps.googleusercontent.com',
//   clientId: '831532615144-qr26fv2fsmfivlpgqesoou4v8jcbedpn.apps.googleusercontent.com',
//   scope: 'profile email',
//   prompt: 'select_account'
// }
// Vue.use(GAuth, gauthOption)




// const apiConfig = {
//   apiKey: "AIzaSyC5AZgdfdNw0SJUQ-RVNgjFU9vCRiAK02w", //"<YOUR_API_KEY>",
//   clientId: "831532615144-qr26fv2fsmfivlpgqesoou4v8jcbedpn.apps.googleusercontent.com",//"<YOUR_CLIENT_ID>.apps.googleusercontent.com",
//   // discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
//   discoveryDocs: [
//     "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"
//   ],
//   scope: "https://www.googleapis.com/auth/calendar.events" //"https://www.googleapis.com/auth/spreadsheets"
//   // see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
// };

// import VueGoogleApi from 'vue-google-api'
// Vue.use(VueGoogleApi, apiConfig)

// import VueGAPI from "vue-gapi";
// Vue.use(VueGAPI, apiConfig);


Vue.config.productionTip = false



Vue.use(Buefy, {
  defaultIconPack: 'fas', //'fas' 'mdi'
  defaultContainerElement: '#content',
  // defaultDateFormatter: (date) => moment(date).format("DD/MM/YYYY"),
  // date-parser: (data) => ()
  // ...
})



// if (
//   process.env.NODE_ENV == 'production' &&
//   window.location.hostname == 'my-domain.com'
// )
if (process.env.NODE_ENV == 'production')
{
  Vue.use(VueMatomo, {
    // Configure your matomo server and site by providing
    host: 'https://piwik.jueewo.org',
    siteId: 30,

    // Changes the default .js and .php endpoint's filename
    // Default: 'piwik'
    trackerFileName: 'piwik',

    // Overrides the autogenerated tracker endpoint entirely
    // Default: undefined
    // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

    // Enables automatically registering pageviews on the router
    router: router,

    // Enables link tracking on regular links. Note that this won't
    // work for routing links (ie. internal Vue router links)
    // Default: true
    enableLinkTracking: true,

    // Require consent before sending tracking information to matomo
    // Default: false
    requireConsent: false,

    // Whether to track the initial page view
    // Default: true
    trackInitialView: true,

    // Whether or not to log debug information
    // Default: false
    debug: false
  })
}

new Vue({
  router,
  store,
  render: h => h(App),
  // fix for issue with: HTML5 History Mode
  // created () {
  //   if (sessionStorage.redirect) {
  //     const redirect = sessionStorage.redirect
  //     delete sessionStorage.redirect
  //     this.$router.push(redirect)
  //   }
  // }
}).$mount('#app')


